import React from 'react'

import injectStyles from 'react-jss'
import styles from './styles'
import { parseMessage } from '../../../../../shared/chat'
import { CHAT_STRING_TYPES } from '../../../../../shared/constants'

const MessageText = ({ value, className }) => (
  <span className={className}>{value}</span>
)
const MessageLink = ({ value, className }) => (
  <a href={value} target="_blank" className={className}>
    {value}
  </a>
)

const ChatText = ({ text, classes }) => {
  const parsedText = parseMessage({ text })
  const message = parsedText.map(({ value, type }, key) =>
    type === CHAT_STRING_TYPES.TEXT ? (
      <MessageText key={key} className={classes.text} value={value} />
    ) : (
      <MessageLink key={key} className={classes.text} value={value} />
    ),
  )

  return <span>{message}</span>
}

export default injectStyles(styles)(ChatText)



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatMessage/contents/ChatText/ChatText.js